/**
 * @generated SignedSource<<7a98fdaad5d675dc3710c63666872b68>>
 * @relayHash 470ef2ef4588460fe03eed125f91c1ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3ae2859b3660f66947e4759260c0a6a95ff3ed9db685bacfe757c96b78662340

import type { ConcreteRequest, Query } from 'relay-runtime';
export type src_EndOfTrialMessageSharedGlobalComponentQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly offering: {
          readonly trial?: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning: {
          readonly firstPreDunningEndTimestamp: number | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type src_EndOfTrialMessageSharedGlobalComponentQuery = {
  response: src_EndOfTrialMessageSharedGlobalComponentQuery$data;
  variables: src_EndOfTrialMessageSharedGlobalComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "AND": [
        {
          "inPreDunning": true
        }
      ]
    }
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "CcpOfferingTrial",
      "kind": "LinkedField",
      "name": "trial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lengthDays"
        }
      ]
    }
  ],
  "type": "CcpOffering"
},
v5 = {
  "kind": "ScalarField",
  "name": "firstPreDunningEndTimestamp"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "offering",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "preDunning",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "entitlement(where:{\"AND\":[{\"inPreDunning\":true}]})"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3ae2859b3660f66947e4759260c0a6a95ff3ed9db685bacfe757c96b78662340",
    "metadata": {},
    "name": "src_EndOfTrialMessageSharedGlobalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dabc51d1fad1542ebb0e4bbf406d549e";

export default node;
